import { BaseEntity } from './base-entity';

export class ListSortModel {
  field: string;
  order: string;

  constructor(field: string, order: string) {
    this.field = field;
    this.order = order;
  }
}

export class PagedListModel {
  content: Array<BaseEntity>;
  size: number;
  totalElements: number;
  totalPages: number;
}
